import { render } from "./MyNavbar.vue?vue&type=template&id=a3049162&scoped=true"
import script from "./MyNavbar.vue?vue&type=script&lang=js"
export * from "./MyNavbar.vue?vue&type=script&lang=js"

import "./MyNavbar.vue?vue&type=style&index=0&id=a3049162&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3049162"]])

export default __exports__